<template>
  <div id="tabBar">
    <div class="bar">
      <div class="logo">
        <a href="http://fanyi.youdao.com/">
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/YDFYlogo.png" alt="" srcset="">
          <h5 v-if="!webPageTrans">免费、即时的多语种在线翻译</h5>
        </a>
      </div>
      <search v-if="webPageTrans" ref="reSearch" :userTurnUrl="userTurnUrl"/>
      <div class="other_products">
        <a href="https://cidian.youdao.com/mobile.html" target="_blank">
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/web_icon_download.png">
          下载有道词典
        </a>
        <span @mouseover="hoverMoreIn" @mouseout="hoverMoreOut">
          更多
        </span>
        <span :class="[ !showMoreList ? 'rotate_restore triangle' : 'rotate triangle']"></span>
      </div>
      <div class="more" v-if="showMoreList" @mouseenter="hoverMoreListIn" @mouseleave="hoverMoreListOut">
        <!-- <router-link tag="a" :to="{ path: '/oneKeyTrans' }" target="_blank">一键翻译 </router-link> -->
        <router-link tag="a" :to="{ path: '/clause', query: { clause: 'statement' }}" target="_blank">免责声明 </router-link>
        <router-link tag="a" :to="{ path: `/complain?complainUrl=${this.userInputUrl}` }" target="_blank">网站投诉 </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './Search'
import { clearInterval } from 'timers';
import { mapState } from "vuex";
export default {
  name: "TabBar",
  props: ['webPageTrans', 'userTurnUrl'],
  data() {
    return {
      value: "",
      liveMoreTimer: '',
      showMoreList: false,
      liveMoreListTimer: ''
    };
  },
  computed: {
    ...mapState([
      "userInputUrl"
    ])
  },
  methods: {
    hoverMoreIn() {
      this.showMoreList = true
      window.clearTimeout(this.liveMoreTimer)
      window.clearTimeout(this.liveMoreListTimer)
    },
    hoverMoreOut() {
      this.liveMoreTimer = setTimeout(() => {
        this.showMoreList = false
      }, 800);
    },
    hoverMoreListIn() {
      window.clearTimeout(this.liveMoreTimer)
      window.clearTimeout(this.liveMoreListTimer)
    },
    hoverMoreListOut() {
      this.liveMoreListTimer = setTimeout(() => {
        this.showMoreList = false
      }, 800);
    },
    reSearch() {
      this.$refs.reSearch.trans()
    }
  },
  components: {
    Search
  }
};
</script>

<style scoped>
#tabBar {
  width: 100%;
  height: 72px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
}
.bar {
  max-width: 1440px;
  min-width: 1106px;
  height: 72px;
  margin: 0 auto;
  position: relative;
}
.bar h5 {
  height: 21px;
  font-size: 16px;
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color: rgba(89, 87, 87, 1);
  line-height: 21px;
  margin-top: 31px;
  float: left;
}

.logo {
  float: left;
}
.logo img {
  width: 90px;
  height: 24px;
  display: inline-block;
  margin: 24px 20px 24px 40px;
  float: left;
}
.other_products {
  float: right;
  height: 72px;
  position: relative;
  line-height: 72px;
}
.other_products a {
  font-size: 12px;
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  display: block;
  font-style: normal;
  float: left;
  margin-right: 40px;
}
.other_products a:hover {
  color:rgba(224,36,51,1);
}

.other_products span {
  font-size: 12px;
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  display: block;
  font-style: normal;
  margin-right: 5px;
  float: left;
}
.other_products img {
  width: 18px;
  height: 18px;
  display: block;
  float: left;
  margin-top: 27px;
  margin-right: 4px;
}
#tabBar .other_products .triangle {
  width: 0;
  height: 0;
  display: block;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #333333;
  margin: -2px 40px 0 5px;
  float: left;
  margin-top: 33px;
}
.more {
  width: 100px;
  overflow: hidden;
  z-index: 99;
  padding: 12px 0;
  background: rgba(255,255,255,1);
  box-shadow: 0px 0px 6px 0px rgba(55,61,82,0.1);
  border-radius: 4px 0px 0px 4px;
  border: 1px solid rgba(240,241,245,1);
  position: absolute;
  top: 58px;
  right: 0;
}
.more a {
  width: 100%;
  display: block;
  text-align: center;
  font-style: normal;
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:17px;
  margin-bottom: 12px;
  text-align: center;
}
.more a:last-child {
  margin: 0;
}
.more a:hover {
  color:rgba(224,36,51,1);
}
.rotate {
  transform-origin:center center; 
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transition: transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -o-transition: -o-transform 0.2s;
  -ms-transition: -ms-transform 0.2s;
}

.rotate_restore {
  transform-origin:center center;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transition: transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -o-transition: -o-transform 0.2s;
  -ms-transition: -ms-transform 0.2s;
}
</style>
